import {
  Button,
  Dialog,
  DialogActions,
  DialogContent,
  DialogContentText,
  DialogTitle,
  useMediaQuery,
} from "@mui/material";
import { FC } from "react";
import { useMutation } from "react-query";
import { toast } from "react-toastify";
import { AxiosError } from "../../../../../utils/api/axiosErrorType";
import { ChannelOrderApi } from "../../../../../utils/api/requests/channelOrder-requests";
import { theme } from "../../../../../theme";
import { useTranslation } from "react-i18next";

interface CancelChannelOrderModalProps {
  open: boolean;
  handleClose: () => void;
  id: number;
  refetch: () => void;
}

export const CancelChannelOrderModal: FC<CancelChannelOrderModalProps> = ({
  open,
  handleClose,
  id,
  refetch,
}) => {
  const { t } = useTranslation();
  const isMobile = useMediaQuery(theme.breakpoints.down("sm"));

  const { mutate, isLoading } = useMutation({
    mutationFn: ChannelOrderApi.cancelChannelOrder,
    onSuccess: () => {
      toast.success(t("channels.cancelChannelModal.channelCanceled"));
      refetch();
      handleClose();
    },
    onError: (error) => {
      const err = error as AxiosError;
      toast.error(err?.response?.data?.detail);
    },
  });

  const handleCancel = async () => {
    mutate([id]);
  };

  return (
    <Dialog
      open={open}
      onClose={handleClose}
      aria-labelledby="alert-dialog-title"
      aria-describedby="alert-dialog-description"
      fullWidth={isMobile}
    >
      <DialogTitle id="alert-dialog-title">
        {t("channels.cancelChannelModal.header")}
      </DialogTitle>
      <DialogContent>
        <DialogContentText
          id="alert-dialog-description"
          sx={{
            width: { xs: "sm", sm: "350px", md: "350px" },
            minHeight: "20px",
          }}
        >
          {t("channels.cancelChannelModal.content")}
        </DialogContentText>
      </DialogContent>
      <DialogActions sx={{ marginBottom: "10px", px: "24px" }}>
        <Button variant="outlined" onClick={handleClose}>
          {t("cancel")}
        </Button>
        <Button
          variant="contained"
          color="primary"
          type="submit"
          disabled={isLoading}
          onClick={handleCancel}
        >
          {t("submit")}
        </Button>
      </DialogActions>
    </Dialog>
  );
};
